import React from 'react';

import { t } from 'ttag';

import Icon from '../../../../ui/icon/icon';

import SvgPerson from './images/person.svg';

import css from './AdditionalTrialText.css';

const AdditionalTrialText: React.FC<React.PropsWithChildren<unknown>> = () => (
    <div className={css.container}>
        <p className={css.subtitle}>{t`Безкоштовно протягом 14 днів`}</p>
        <h4 className={css.title}>
            {t`Спробуйте більше можливостей сервісу!`}
        </h4>
        <p>{t`Привіт! Дякую, що обрав «Вчасно». Наша мета – позбавити тебе проблем із підписанням та доставкою документів.`}</p>
        <p>{t`Саме тому ми створили свій сервіс таким, щоб кожен – від підприємця-початківця до ТОП менеджера міжнародного холдингу – отримав найкращий інструмент для роботи з ЕДО. Просто обирай, який документ і кому відправити, а «Вчасно» зробить усе інше.`}</p>
        <br />
        <p>{t`А ще більше задоволення від командної роботи з документами ти отримаєш завдяки додатковим можливостям «Вчасно». Підключай їх і ставай професіоналом з документообігу!`}</p>
        <div className={css.person}>
            <div className={css.personIcon}>
                <Icon glyph={SvgPerson} />
            </div>
            <div>
                <p className={css.personName}>{t`Антон Скоков`}</p>
                <p>{t`CEO Vchasno`}</p>
            </div>
        </div>
    </div>
);

export default AdditionalTrialText;
